import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { logout, logoutNow } from "../../redux/user/userActions";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
//MUI imports
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import Link from "@material-ui/core/Link";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
//Icons
import BookmarksIcon from "@material-ui/icons/Bookmarks";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import PersonIcon from "@material-ui/icons/Person";
import HomeIcon from "@material-ui/icons/Home";
import ListAltIcon from "@material-ui/icons/ListAlt";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import InfoIcon from "@material-ui/icons/Info";
import PhoneIcon from "@material-ui/icons/Phone";
import MenuIcon from "@material-ui/icons/Menu";
import GTranslateIcon from "@material-ui/icons/GTranslate";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
//My Components
import LoginModal from "../LoginModal/Index";
import * as TextLoader from "../../components/StaticTexts/Index";
import { Formik } from "formik";
import "./HomePageHeader.css";

const useStyles = makeStyles((theme) => ({
    headerMobile: {
        fontSize: "15px !important",
        backgroundImage: "url(/images/home-page-header/bg-phone.jpg)",
        minHeight: "518px",
        boxShadow: "none",
        paddingRight: "0px",
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "transparent",
        direction: "rtl",
        marginTop: "0px",
        paddingTop: "0px",
    },
    headerTablet: {
        fontSize: "17px !important",
        backgroundImage: "url(/images/home-page-header/bg.jpg)",
        minHeight: "399px",
        paddingLeft: 0,
        boxShadow: "none",
        backgroundSize: "contain",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "transparent",
        direction: "rtl",
        marginTop: "0px",
        paddingTop: "0px",
    },
    headerDesktop: {
        fontSize: "17px !important",
        backgroundImage: "url(/images/home-page-header/bg.jpg)",
        minHeight: "715px",
        paddingRight: "0px",
        paddingLeft: "0px",
        boxShadow: "none",
        backgroundSize: "contain",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "transparent",
        direction: "rtl",
        marginTop: "0px",
        paddingTop: "0px",
    },
    mainTitle: {
        [theme.breakpoints.up("sm")]: {
            fontSize: "1.8rem",
            fontWeight: "700",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.6rem",
            fontWeight: "700",
        },
    },
    slogan: {
        [theme.breakpoints.up("sm")]: {
            fontSize: "1.5rem",
            marginTop: "25px",
            marginBottom: "15px",
            fontWeight: "700",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.4rem",
            marginTop: "25px",
            marginBottom: "25px",
            fontWeight: "700",
        },
    },
    bargC: {
        [theme.breakpoints.down("lg")]: {
            marginTop: "-110px",
        },
    },
    menuItem: {
        fontFamily: "Dana-FaNum",
    },
    logo: {
        fontFamily: "Dana-FaNum",
        fontWeight: 600,
        color: "#FFFEFE",
        textAlign: "left",
    },
    input: {
        fontFamily: "Dana-FaNum",
        backgroundColor: "#fff",
        flex: 1,
        borderRadius: "15px",
        textAlign: "right",
        direction: "rtl",
    },
    menuButton: {
        fontFamily: "Dana-FaNum",
        fontWeight: 700,
        fontSize: "17px",
        marginLeft: "15px",
        [theme.breakpoints.up("md")]: {
            fontSize: "17px !important",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: "15px !important",
        },
    },
    drawerPaper: {
        backgroundColor: "#950000",
    },
    drawerContainer: {
        width: "280px",
        textAlign: "right",
    },
    base: {
        flexGrow: 1,
    },
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1534,
        },
    },
    noneStylePaper: {
        boxShadow: "none",
        backgroundColor: "transparent !important",
        border: "none",
    },
    grid: {
        boxShadow: "none",
    },
    paperWLP: {
        padding: theme.spacing(1),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
    },
    paperNoPadding: {
        padding: 0,
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
    },
    inputBox: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    bargHeaderDesktop: {
        [theme.breakpoints.up("lg")]: {
            top: '201px',
            left: '-44px',
            width: '128px',
            position: 'relative',
        },
        [theme.breakpoints.down("lg")]: {
            width: "125px",
            position: "relative",
            top: "123px",
            left: "-38px",
        },
    }
}));

const Header = ({ lang }) => {
    const dispatch = useDispatch();
    const [userData, setUserData] = useState([]);
    const setStateCallback = useCallback((state) => {
        setUserData(state);
    }, []);
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const { reduxCartItems } = useSelector((state) => state.cart);
    const [PageLoading, setPageLoading] = useState(false);
    const history = useHistory();
    const [staticText, setStaticText] = useState({});
    const [headerW, setHeaderW] = useState(0);
    const [headersData, setHeadersData] = useState([]);
    const {
        header,
        headerMobile,
        headerTablet,
        headerDesktop,
        bargC,
        mainTitle,
        slogan,
        menuButton,
        paperNoPadding,
        paperWLP,
        inputBox,
        iconButton,
        noneStylePaper,
        menuItem,
        toolbar,
        container,
        drawerContainer,
        drawerPaper,
        base,
        paper,
        bargHeaderDesktop
    } = useStyles();
    const [menuBg, setMenuBg] = useState("/images/home-page-header/bg.jpg"); //'/images/home-page-header/bg.jpg' - '/images/header-bg.jpg'
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = React.useState(false);
    const anchorRef2 = React.useRef(null);
    const anchorRef = React.useRef(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const handleDispatch = (event) => {
        if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
            return;
        }
        setOpen2(false);
        dispatch(logout());
    };

    const handleToggle2 = () => {
        setOpen2((prevOpen2) => !prevOpen2);
    };

    const handleClose2 = (event) => {
        if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
            return;
        }

        setOpen2(false);
    };

    function handleListKeyDown2(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen2(false);
        }
    }

    const prevOpen2 = React.useRef(open2);
    React.useEffect(() => {
        if (prevOpen2.current === true && open === false) {
            anchorRef2.current.focus();
        }

        prevOpen2.current = open2;
    }, [open2]);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const changeLang = (targetLang) => {
        if (targetLang === "fa") {
            if (
                history.location.pathname.includes("/products") ||
                history.location.pathname.includes("/articels") ||
                history.location.pathname.includes("/product") ||
                history.location.pathname.includes("/article")
            )
                localStorage.setItem("lang", targetLang);
            else {
                localStorage.setItem("lang", targetLang);
                history.push(history.location.pathname.replace("/ar/", ""));
            }
            window.location.reload(false);
        } else {
            if (
                history.location.pathname.includes("/products") ||
                history.location.pathname.includes("/articels") ||
                history.location.pathname.includes("/product") ||
                history.location.pathname.includes("/article")
            )
                localStorage.setItem("lang", targetLang);
            else {
                localStorage.setItem("lang", targetLang);
                history.push("/" + targetLang + history.location.pathname);
            }
            window.location.reload(false);
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const onClose = () => {
        setIsModalOpen(false);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const changeToFa = (event) => {
        changeLang("fa");
    };
    const changeToAr = (event) => {
        changeLang("ar");
    };

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
    }

    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        if (localStorage.getItem("token")) {
            const fetchData = async () => {
                const config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                };
                try {
                    const response = await axios.get("/api/accounts/profile", config);

                    const data = await response.data;

                    if (data.status === "ok") {
                        setStateCallback(data);
                    } else {
                        dispatch(logoutNow());
                    }
                } catch (error) {
                    if (error.response.status === 401) {
                        dispatch(logoutNow());
                    }
                }
            };

            fetchData();
        }
    }, [setStateCallback]);

    const [state, setState] = useState({
        mobileView: false,
        tabletView: false,
        drawerOpen: false,
    });

    const { mobileView, tabletView, drawerOpen } = state;

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth > 900
                ? setState((prevState) => ({
                    ...prevState,
                    mobileView: false,
                    tabletView: false,
                }))
                : window.innerWidth < 901 && window.innerWidth > 477
                    ? setState((prevState) => ({
                        ...prevState,
                        mobileView: false,
                        tabletView: true,
                    }))
                    : setState((prevState) => ({
                        ...prevState,
                        mobileView: true,
                        tabletView: false,
                    }));

            // return window.innerWidth < 900
            //     ? setState((prevState) => ({ ...prevState, mobileView: true }))
            //     : setState((prevState) => ({ ...prevState, mobileView: false }));
        };
        setResponsiveness();
        window.addEventListener("resize", () => setResponsiveness());
        setStaticText(TextLoader.staticTextLoader("header", lang));
        setHeadersData(TextLoader.staticTextLoader("menu", lang));
    }, []);

    const displayDesktop = () => {
        return (
            <AppBar position="static" className={headerDesktop}>
                <Toolbar className={toolbar} className="desktop">
                    <Grid justify="top" container spacing={2}>
                        <Grid item md={7}>
                            <Paper
                                style={{ textAlign: "right", color: "#ffffff" }}
                                alignItems="right"
                                className={paper}
                            >
                                <Box evelation={0}>
                                    <div>{getMenuButtons()}</div>
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item md={5}>
                            <Paper className={paperWLP}>
                                <Box evelation={0} m={0} p={0}>
                                    <div
                                        className="displayTable"
                                        style={{ width: "70%", marginTop: "6px", float: "left" }}
                                    >
                                        <div className="cell vertical-middle text-left">
                                            <Button
                                                ref={anchorRef}
                                                aria-controls={open ? "menu-list-grow" : undefined}
                                                aria-haspopup="true"
                                                onClick={handleToggle}
                                            >
                                                <GTranslateIcon style={{ fill: "#fff" }} />
                                            </Button>
                                            <Popper
                                                open={open}
                                                anchorEl={anchorRef.current}
                                                role={undefined}
                                                transition
                                                disablePortal
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin:
                                                                placement === "bottom"
                                                                    ? "center top"
                                                                    : "center bottom",
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={handleClose}>
                                                                <MenuList
                                                                    autoFocusItem={open}
                                                                    id="menu-list-grow"
                                                                    onKeyDown={handleListKeyDown}
                                                                >
                                                                    <MenuItem className={menuItem}>
                                                                        فارسی
                                  </MenuItem>
                                                                    <MenuItem className={menuItem}>عربی</MenuItem>
                                                                </MenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                    //  onClick={changeToFa}  onClick={changeToAr}
                                                )}
                                            </Popper>
                                        </div>
                                        <div className="cell vertical-middle text-left">
                                            {userData.length === 0 ? (
                                                <span className="shopping-bag cur-pointer">
                                                    <RouterLink onClick={openModal}>
                                                        <BookmarksIcon />
                                                    </RouterLink>
                                                </span>
                                            ) : (
                                                <span className="shopping-bag cur-pointer">
                                                    <RouterLink to="/profile/bookmarks">
                                                        <BookmarksIcon />
                                                    </RouterLink>
                                                </span>
                                            )}
                                        </div>
                                        <div className="cell vertical-middle text-left">
                                            <span className="shopping-bag cur-pointer">
                                                <RouterLink to="/cart">
                                                    <LocalMallIcon />
                                                    <span className="iib">{reduxCartItems.length}</span>
                                                </RouterLink>
                                            </span>
                                        </div>
                                        <div className="cell vertical-middle">
                                            {userData.length === 0 ? (
                                                <>
                                                    {userInfo && (
                                                        <>
                                                            {userInfo.status === "error" ? (
                                                                <Button
                                                                    className="account-btn"
                                                                    onClick={openModal}
                                                                    variant="danger"
                                                                >
                                                                    <PersonIcon /> {staticText.accountBtn}{" "}
                                                                </Button>
                                                            ) : (
                                                                <>
                                                                    {userInfo.length !== 0 && (
                                                                        <>
                                                                            <Button
                                                                                className="account-btn"
                                                                                onClick={handleToggle2}
                                                                                variant="danger"
                                                                                ref={anchorRef2}
                                                                                style={{
                                                                                    padding: "5px 8px 5px 8px",
                                                                                    width: "100%",
                                                                                    textAlign: "center",
                                                                                }}
                                                                                aria-controls={
                                                                                    open2 ? "menu-list-grow" : undefined
                                                                                }
                                                                                aria-haspopup="true"
                                                                            >
                                                                                <PermIdentityIcon
                                                                                    style={{ fill: "#fff" }}
                                                                                />

                                                                                <span
                                                                                    style={{
                                                                                        display: "inline-block",
                                                                                        marginRight: "7px",
                                                                                    }}
                                                                                >
                                                                                    {userInfo.fullName}
                                                                                </span>
                                                                            </Button>
                                                                            <Popper
                                                                                open={open2}
                                                                                anchorEl={anchorRef2.current}
                                                                                role={undefined}
                                                                                transition
                                                                                disablePortal
                                                                            >
                                                                                {({ TransitionProps, placement }) => (
                                                                                    <Grow
                                                                                        {...TransitionProps}
                                                                                        style={{
                                                                                            transformOrigin:
                                                                                                placement === "bottom"
                                                                                                    ? "center top"
                                                                                                    : "center bottom",
                                                                                        }}
                                                                                    >
                                                                                        <Paper>
                                                                                            <ClickAwayListener
                                                                                                onClickAway={handleClose2}
                                                                                            >
                                                                                                <MenuList
                                                                                                    autoFocusItem={open2}
                                                                                                    id="menu-list-grow"
                                                                                                    onKeyDown={handleListKeyDown2}
                                                                                                >
                                                                                                    <MenuItem
                                                                                                        onClick={handleClose2}
                                                                                                    >
                                                                                                        <RouterLink
                                                                                                            to="/profile"
                                                                                                            style={{
                                                                                                                fontSize: "0.920rem",
                                                                                                            }}
                                                                                                        >
                                                                                                            ویرایش اطلاعات کاربری
                                                    </RouterLink>
                                                                                                    </MenuItem>
                                                                                                    <MenuItem
                                                                                                        style={{
                                                                                                            fontSize: "0.920rem",
                                                                                                        }}
                                                                                                        onClick={handleDispatch}
                                                                                                    >
                                                                                                        خروج
                                                  </MenuItem>
                                                                                                </MenuList>
                                                                                            </ClickAwayListener>
                                                                                        </Paper>
                                                                                    </Grow>
                                                                                )}
                                                                            </Popper>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                    {!userInfo && (
                                                        <Button
                                                            className="account-btn"
                                                            onClick={openModal}
                                                            variant="danger"
                                                        >
                                                            <PersonIcon /> {staticText.accountBtn}{" "}
                                                        </Button>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <Button
                                                        className="account-btn"
                                                        onClick={handleToggle2}
                                                        variant="danger"
                                                        ref={anchorRef2}
                                                        style={{
                                                            padding: "5px 8px 5px 8px",
                                                            width: "100%",
                                                            textAlign: "center",
                                                        }}
                                                        aria-controls={open2 ? "menu-list-grow" : undefined}
                                                        aria-haspopup="true"
                                                    >
                                                        {userData.data.imageURL ? (
                                                            <img
                                                                src={userData.data.imageURL}
                                                                width="24px"
                                                                height="24px"
                                                                style={{ borderRadius: "50%" }}
                                                            />
                                                        ) : (
                                                            <PermIdentityIcon style={{ fill: "#fff" }} />
                                                        )}
                                                        <span
                                                            style={{
                                                                display: "inline-block",
                                                                marginRight: "7px",
                                                            }}
                                                        >
                                                            {userData.data.fullName}
                                                        </span>
                                                    </Button>
                                                    <Popper
                                                        open={open2}
                                                        anchorEl={anchorRef2.current}
                                                        role={undefined}
                                                        transition
                                                        disablePortal
                                                    >
                                                        {({ TransitionProps, placement }) => (
                                                            <Grow
                                                                {...TransitionProps}
                                                                style={{
                                                                    transformOrigin:
                                                                        placement === "bottom"
                                                                            ? "center top"
                                                                            : "center bottom",
                                                                }}
                                                            >
                                                                <Paper>
                                                                    <ClickAwayListener onClickAway={handleClose2}>
                                                                        <MenuList
                                                                            autoFocusItem={open2}
                                                                            id="menu-list-grow"
                                                                            onKeyDown={handleListKeyDown2}
                                                                        >
                                                                            <MenuItem onClick={handleClose2}>
                                                                                <RouterLink
                                                                                    to="/profile"
                                                                                    style={{ fontSize: "0.920rem" }}
                                                                                >
                                                                                    ویرایش اطلاعات کاربری
                                        </RouterLink>
                                                                            </MenuItem>
                                                                            <MenuItem
                                                                                style={{ fontSize: "0.920rem" }}
                                                                                onClick={handleDispatch}
                                                                            >
                                                                                خروج
                                      </MenuItem>
                                                                        </MenuList>
                                                                    </ClickAwayListener>
                                                                </Paper>
                                                            </Grow>
                                                        )}
                                                    </Popper>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item md={6}>
                            <Paper evelation={0} className={noneStylePaper}>
                                <Box
                                    evelation={0}
                                    className={noneStylePaper}
                                    mt={{ lg: 28, md: 23.5, xl: 28 }}
                                    textAlign="left"
                                >
                                    {/* width: '65%', position: 'relative', left: '50px', top: '11px' */}
                                    <img
                                        alt=""
                                        style={{
                                            width: "65%",
                                            position: "relative",
                                            left: "29px",
                                            top: "53px",
                                        }}
                                        src="/images/home-page-header/nuts.png"
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item md={6} style={{ textAlign: "left" }}>
                            <Paper className={paper}>
                                <Box evelation={0} textAlign="center" color="#fff">
                                    <img
                                        alt=""
                                        src="/images/home-page-header/logo.png"
                                        style={{ width: "200px" }}
                                    />
                                    <Typography variant="h1" className={mainTitle}>
                                        {staticText.mainTitle}
                                    </Typography>
                                    <Typography variant="h2" className={slogan}>
                                        {staticText.slogan}
                                    </Typography>
                                    <Formik
                                        initialValues={{ keyword: "" }}
                                        validate={(values) => {
                                            const errors = {};
                                            if (!values.keyword) {
                                                errors.keyword = "Required";
                                            }
                                            return errors;
                                        }}
                                        onSubmit={(values, { setSubmitting }) => {
                                            setTimeout(() => {
                                                if (values.keyword.trim() !== "") {
                                                    history.push({
                                                        pathname: "/products/",
                                                        search: `&keyword=${values.keyword.trim()}`,
                                                    });
                                                }
                                            }, 400);
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                        }) => (
                                            <form
                                                onSubmit={handleSubmit}
                                                style={{ margin: "0px 39px", width: "93%" }}
                                                className="desktopHeader"
                                            >
                                                <FormControl
                                                    style={{ margin: "10px auto", width: "100%" }}
                                                >
                                                    <table
                                                        className="tableSearchBox"
                                                        border="0"
                                                        padding="0"
                                                        margin="0"
                                                        spacing="0"
                                                        style={{ marginRight: "-40px" }}
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <td className="inputContiner">
                                                                    <input
                                                                        type="text"
                                                                        name="keyword"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        placeholder={staticText.searchText}
                                                                        value={values.keyword}
                                                                        className="input"
                                                                    />
                                                                </td>
                                                                <td className="btnContiner">
                                                                    <button type="submit" className="btnSearch">
                                                                        <SearchIcon
                                                                            style={{
                                                                                position: "relative",
                                                                                top: "4px",
                                                                            }}
                                                                        />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </FormControl>
                                            </form>
                                        )}
                                    </Formik>
                                    {/* <Box m={2} textAlign="center">
                                        <span class="text" style={{ color: '#fff' }}><strong class="bold">به مناسبت افتتاحیه: </strong> ارسال رایگان برای همشهریان مشهدی </span>
                                    </Box> */}
                                </Box>
                            </Paper>
                            {/* 14 36 116 */}
                            <img
                                alt=""
                                className={bargHeaderDesktop}
                                id="bargHeaderDesktop"
                                src="/images/home-page-header/leaves.png"
                            />
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        );
    };

    const displayTablet = () => {
        const handleDrawerOpen = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: true }));

        const handleDrawerClose = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: false }));

        const handleRadioChange = (event) => {
            if (event.target.value === "ar" && localStorage.getItem("lang") !== "ar") {
                localStorage.setItem("lang", "ar");
                history.push("/ar");
                window.location.reload(false);
            } else {
                if (localStorage.getItem("lang") !== "fa") {
                    localStorage.setItem("lang", "fa");
                    //changeMenu(localStorage.getItem("lang"));
                    history.push("/");
                    window.location.reload(false);
                }
            }
        };

        return (
            <AppBar position="static" className={headerTablet}>
                <Toolbar>
                    <Grid container>
                        <Grid item sm={6}>
                            <Box evelation={0} mt={0} textAlign="right" className="btnToggle">
                                <IconButton
                                    style={{ marginTop: "2px" }}
                                    {...{
                                        edge: "start",
                                        color: "inherit",
                                        "aria-label": "menu",
                                        "aria-haspopup": "true",
                                        onClick: handleDrawerOpen,
                                    }}
                                >
                                    <MenuIcon className="menuToggleBtn" />
                                </IconButton>
                            </Box>
                        </Grid>
                        <Grid item sm={6} className={noneStylePaper}>
                            <Box evelation={0}>
                                <div
                                    className="displayTable"
                                    style={{ width: "100%", float: "left", marginTop: "15px" }}
                                >
                                    <div className="cell vertical-middle text-left">
                                        <Button
                                            ref={anchorRef}
                                            aria-controls={open ? "menu-list-grow" : undefined}
                                            aria-haspopup="true"
                                            onClick={handleToggle}
                                        >
                                            <GTranslateIcon style={{ fill: "#fff" }} />
                                        </Button>
                                        <Popper
                                            open={open}
                                            anchorEl={anchorRef.current}
                                            role={undefined}
                                            transition
                                            disablePortal
                                        >
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{
                                                        transformOrigin:
                                                            placement === "bottom"
                                                                ? "center top"
                                                                : "center bottom",
                                                    }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleClose}>
                                                            <MenuList
                                                                autoFocusItem={open}
                                                                id="menu-list-grow"
                                                                onKeyDown={handleListKeyDown}
                                                            >
                                                                <MenuItem className={menuItem}>فارسی</MenuItem>
                                                                <MenuItem className={menuItem}>عربی</MenuItem>
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                                //  onClick={changeToFa}  onClick={changeToAr}
                                            )}
                                        </Popper>
                                    </div>
                                    <div className="cell vertical-middle text-left">
                                        <span className="shopping-bag cur-pointer">
                                            <RouterLink to="/profile/bookmarks">
                                                <BookmarksIcon />
                                            </RouterLink>
                                        </span>
                                    </div>
                                    <div className="cell vertical-middle text-left">
                                        <span className="shopping-bag cur-pointer">
                                            <RouterLink to="/cart">
                                                <LocalMallIcon />
                                                <span className="iib">{reduxCartItems.length}</span>
                                            </RouterLink>
                                        </span>
                                    </div>
                                    <div className="cell vertical-middle">
                                        {userData.length === 0 ? (
                                            <Button
                                                className="account-btn"
                                                onClick={openModal}
                                                variant="danger"
                                            >
                                                <PersonIcon /> {staticText.accountBtn}{" "}
                                            </Button>
                                        ) : (
                                            <>
                                                <Button
                                                    className="account-btn"
                                                    onClick={handleToggle2}
                                                    variant="danger"
                                                    ref={anchorRef2}
                                                    style={{
                                                        padding: "5px 8px 5px 8px",
                                                        width: "100%",
                                                        textAlign: "center",
                                                    }}
                                                    aria-controls={open2 ? "menu-list-grow" : undefined}
                                                    aria-haspopup="true"
                                                >
                                                    {userData.data.imageURL ? (
                                                        <img
                                                            src={userData.data.imageURL}
                                                            width="24px"
                                                            height="24px"
                                                            style={{ borderRadius: "50%" }}
                                                        />
                                                    ) : (
                                                        <PermIdentityIcon style={{ fill: "#fff" }} />
                                                    )}
                                                    <span
                                                        style={{
                                                            display: "inline-block",
                                                            marginRight: "7px",
                                                        }}
                                                    >
                                                        {userData.data.fullName}
                                                    </span>
                                                </Button>
                                                <Popper
                                                    open={open2}
                                                    anchorEl={anchorRef2.current}
                                                    role={undefined}
                                                    transition
                                                    disablePortal
                                                >
                                                    {({ TransitionProps, placement }) => (
                                                        <Grow
                                                            {...TransitionProps}
                                                            style={{
                                                                transformOrigin:
                                                                    placement === "bottom"
                                                                        ? "center top"
                                                                        : "center bottom",
                                                            }}
                                                        >
                                                            <Paper>
                                                                <ClickAwayListener onClickAway={handleClose2}>
                                                                    <MenuList
                                                                        autoFocusItem={open2}
                                                                        id="menu-list-grow"
                                                                        onKeyDown={handleListKeyDown2}
                                                                    >
                                                                        <MenuItem onClick={handleClose2}>
                                                                            <RouterLink
                                                                                to="/profile"
                                                                                style={{ fontSize: "0.920rem" }}
                                                                            >
                                                                                ویرایش اطلاعات کاربری
                                      </RouterLink>
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            style={{ fontSize: "0.920rem" }}
                                                                            onClick={handleDispatch}
                                                                        >
                                                                            خروج
                                    </MenuItem>
                                                                    </MenuList>
                                                                </ClickAwayListener>
                                                            </Paper>
                                                        </Grow>
                                                    )}
                                                </Popper>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Box>
                        </Grid>
                    </Grid>
                    <Drawer
                        {...{
                            anchor: "right",
                            open: drawerOpen,
                            onClose: handleDrawerClose,
                            classes: { paper: drawerPaper },
                        }}
                    >
                        <div className={drawerContainer + " mobileMenu"}>
                            <div
                                className="menu-top-box"
                                style={{
                                    backgroundImage: `url('/images/home-page-header/menu-top.png')`,
                                }}
                            >
                                <img
                                    src="/images/home-page-header/logo.png"
                                    className="menu-img "
                                />
                                <h3 className="menu-h3">{staticText.mainTitle}</h3>
                            </div>
                            <p>&nbsp;</p>
                            {getDrawerChoices()}
                            <p className="menuLang">
                                <GTranslateIcon /> <span>{staticText.lang}</span>
                            </p>
                            <RadioGroup
                                row
                                aria-label="position"
                                name="position"
                                defaultValue={localStorage.getItem("lang")}
                                style={{ marginRight: "40px" }}>
                                <FormControlLabel
                                    value="fa"
                                    color="#ffffff"
                                    control={<Radio color="success" />}
                                    label="فارسی"
                                />
                                <FormControlLabel
                                    value="ar"
                                    color="#ffffff"
                                    control={<Radio color="success" />}
                                    label="عربی"
                                />
                            </RadioGroup>
                            <Box mt={1} mr={3} textAlign="right">
                                <p style={{ marginTop: '0px', fontSize: '1rem' }}><a style={{ color: '#fff', fontSize: '0.9rem' }} target="_blank" href="https://www.asraweb.com/"><img style={{ height: '23px', position: 'relative', top: '5px' }} src="/images/asraweb-logo.png" /></a><span style={{ fontSize: '0.9rem', marginRight: '5px', color: '#fff' }}>(دپارتمان یکسو)</span></p>
                            </Box>
                        </div>
                    </Drawer>
                </Toolbar>
                <Toolbar className={toolbar} className="tablet">
                    <Grid justify="center" container spacing={2}>
                        <Grid item sm={6}>
                            <Paper evelation={0} className={noneStylePaper}>
                                <Box
                                    evelation={0}
                                    className={noneStylePaper}
                                    mt={9}
                                    textAlign="center"
                                >
                                    <img
                                        alt=""
                                        style={{ width: "100%" }}
                                        src="/images/home-page-header/nuts.png"
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item sm={6} justify="top" style={{ textAlign: "left" }}>
                            <Paper className={noneStylePaper}>
                                <Box
                                    mt={3}
                                    evelation={0}
                                    textAlign="center"
                                    color="#fff"
                                    className={noneStylePaper}
                                >
                                    <img
                                        alt=""
                                        src="/images/home-page-header/logo.png"
                                        style={{ width: "124px", marginRight: "30px" }}
                                    />
                                    <h1
                                        style={{
                                            fontSize: "1rem",
                                            marginBottom: "2px",
                                            marginTop: "0px",
                                        }}
                                    >
                                        {staticText.mainTitle}
                                    </h1>
                                    <h2 style={{ fontSize: "0.90rem" }}>{staticText.slogan}</h2>
                                    <Formik
                                        initialValues={{ keyword: "" }}
                                        validate={(values) => {
                                            const errors = {};
                                            if (!values.keyword) {
                                                errors.keyword = "Required";
                                            }
                                            return errors;
                                        }}
                                        onSubmit={(values, { setSubmitting }) => {
                                            setTimeout(() => {
                                                if (values.keyword.trim() !== "") {
                                                    history.push({
                                                        pathname: "/products/",
                                                        search: `&keyword=${values.keyword.trim()}`,
                                                    });
                                                }
                                            }, 400);
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                        }) => (
                                            <form
                                                onSubmit={handleSubmit}
                                                style={{ margin: "0px 21px", width: "93%" }}
                                            >
                                                <FormControl style={{ width: "100%" }}>
                                                    <table
                                                        className="tableSearchBox"
                                                        padding="0"
                                                        margin="0"
                                                        spacing="0"
                                                        border="0"
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    className="inputContiner"
                                                                    style={{ width: "80%" }}
                                                                >
                                                                    <input
                                                                        style={{
                                                                            width: "100%",
                                                                            padding: "8px !important",
                                                                        }}
                                                                        type="text"
                                                                        name="keyword"
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        placeholder={staticText.searchText}
                                                                        value={values.keyword}
                                                                    />
                                                                </td>
                                                                <td
                                                                    className="btnContiner"
                                                                    style={{ width: "20%" }}
                                                                >
                                                                    <button
                                                                        type="submit"
                                                                        className="btnSearch"
                                                                        style={{
                                                                            textAlign: "center",
                                                                            height: "39px",
                                                                        }}
                                                                    >
                                                                        <SearchIcon style={{ marginTop: "5px" }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </FormControl>
                                            </form>
                                        )}
                                    </Formik>
                                    <Box m={2} textAlign="center">
                                        <span>ارسال رایگان برای ساکنین مشهد مقدس</span>
                                    </Box>
                                </Box>
                            </Paper>
                            <img
                                alt=""
                                style={{
                                    width: "116px",
                                    position: "relative",
                                    top: "43px",
                                    left: "-36px",
                                }}
                                id="bargHeaderDesktop"
                                src="/images/home-page-header/leaves.png"
                            />
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        );
    };

    const displayMobile = () => {
        const handleDrawerOpen = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: true }));

        const handleDrawerClose = () =>
            setState((prevState) => ({ ...prevState, drawerOpen: false }));

        const handleRadioChange = (event) => {
            if (event.target.value === "ar" && localStorage.getItem("lang") !== "ar") {
                changeLang("ar");
            } else {
                changeLang("fa");
            }
        };

        return (
            <AppBar position="static" className={headerMobile}>
                <Toolbar>
                    <Grid
                        container
                        className={base + " " + lang}
                        justify="center"
                        alignItems="center"
                    >
                        <Grid
                            justify="center"
                            alignItems="top"
                            className={container}
                            container
                            spacing={0}
                        >
                            <Grid item xs={12}>
                                <Box evelation={0}>
                                    <div
                                        className="displayTable"
                                        style={{ width: "100%", marginTop: "6px", float: "left" }}
                                    >
                                        <div
                                            className="cell vertical-middle text-center"
                                            style={{ width: "20%", textAlign: "center" }}
                                        >
                                            <IconButton
                                                style={{ paddingTop: "14px", marginTop: "5px" }}
                                                {...{
                                                    edge: "start",
                                                    color: "inherit",
                                                    "aria-label": "menu",
                                                    "aria-haspopup": "true",
                                                    onClick: handleDrawerOpen,
                                                }}
                                            >
                                                <MenuIcon className="menuToggleBtn" />
                                            </IconButton>
                                        </div>
                                        <div className="cell vertical-middle">
                                            <RouterLink to="/cart" style={{ marginRight: "8px" }}>
                                                <LocalMallIcon
                                                    style={{
                                                        marginTop: "10px",
                                                        width: "1.3em",
                                                        height: "1.3em",
                                                        color: "#fff",
                                                    }}
                                                />
                                                <span className="iib">{reduxCartItems.length}</span>
                                            </RouterLink>
                                        </div>
                                        <div
                                            className="cell vertical-middle text-left"
                                            style={{ width: "20%" }}
                                        >
                                            <RouterLink to="/cart">
                                                <BookmarksIcon
                                                    style={{
                                                        width: "1.3em",
                                                        height: "1.3em",
                                                        marginTop: "9px",
                                                        color: "#fff",
                                                    }}
                                                />
                                            </RouterLink>
                                        </div>
                                        {userData.length === 0 ? (
                                            <div
                                                className="cell vertical-middle text-center"
                                                style={{ width: "15%" }}
                                            >
                                                <span className="cur-pointer" onClick={openModal}>
                                                    <PersonIcon
                                                        style={{
                                                            marginTop: "9px",
                                                            marginRight: "9px",
                                                            width: "1.4em",
                                                            height: "1.4em",
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                        ) : (
                                            <div
                                                className="cell vertical-middle text-center"
                                                style={{ width: "20%" }}
                                            >
                                                <Avatar
                                                    onClick={handleToggle2}
                                                    ref={anchorRef2}
                                                    aria-controls={open2 ? "menu-list-grow" : undefined}
                                                    aria-haspopup="true"
                                                    style={{ margin: "0px auto", cursor: "pointer" }}
                                                    alt=""
                                                    src={userData.data.imageURL}
                                                />
                                                <Popper
                                                    open={open2}
                                                    anchorEl={anchorRef2.current}
                                                    role={undefined}
                                                    style={{ marginTop: "10px" }}
                                                    transition
                                                    disablePortal
                                                >
                                                    {({ TransitionProps, placement }) => (
                                                        <Grow
                                                            {...TransitionProps}
                                                            style={{
                                                                transformOrigin:
                                                                    placement === "bottom"
                                                                        ? "center top"
                                                                        : "center bottom",
                                                            }}
                                                        >
                                                            <Paper>
                                                                <ClickAwayListener onClickAway={handleClose2}>
                                                                    <MenuList
                                                                        autoFocusItem={open2}
                                                                        id="menu-list-grow"
                                                                        onKeyDown={handleListKeyDown2}
                                                                    >
                                                                        <MenuItem onClick={handleClose2}>
                                                                            <RouterLink
                                                                                to="/profile"
                                                                                style={{ fontSize: "0.920rem" }}
                                                                            >
                                                                                ویرایش اطلاعات کاربری
                                      </RouterLink>
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            style={{ fontSize: "0.920rem" }}
                                                                            onClick={handleDispatch}
                                                                        >
                                                                            خروج
                                    </MenuItem>
                                                                    </MenuList>
                                                                </ClickAwayListener>
                                                            </Paper>
                                                        </Grow>
                                                    )}
                                                </Popper>
                                            </div>
                                        )}
                                    </div>
                                </Box>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                style={{ textAlign: "center", margin: "0px auto" }}
                            >
                                <Box evelation={0}>
                                    <div className="mobile-logo-title-box">
                                        <img
                                            alt=""
                                            src="/images/home-page-header/logo.png"
                                            style={{ width: "150px" }}
                                        />
                                        <h1
                                            style={{
                                                color: "#fff",
                                                fontSize: "20px",
                                                fontWeight: "700",
                                                marginTop: "10px",
                                            }}
                                        >
                                            {staticText.mainTitle}
                                        </h1>
                                        <h2
                                            style={{
                                                color: "#fff",
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                margin: "20px auto 40px",
                                            }}
                                        >
                                            {staticText.slogan}
                                        </h2>
                                    </div>
                                    <Formik
                                        initialValues={{ keyword: "" }}
                                        validate={(values) => {
                                            const errors = {};
                                            if (!values.keyword) {
                                                errors.keyword = "Required";
                                            }
                                            return errors;
                                        }}
                                        onSubmit={(values, { setSubmitting }) => {
                                            setTimeout(() => {
                                                if (values.keyword.trim() !== "") {
                                                    history.push({
                                                        pathname: "/products/",
                                                        search: `&keyword=${values.keyword.trim()}`,
                                                    });
                                                }
                                            }, 400);
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting,
                                        }) => (
                                            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                                                <FormControl style={{ width: "100%" }}>
                                                    <table
                                                        className="tableSearchBox"
                                                        border="0"
                                                        padding="0"
                                                        margin="0"
                                                        spacing="0"
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    className="inputContiner"
                                                                    style={{ width: "70%" }}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        name="keyword"
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "18px",
                                                                            padding: "7px !important",
                                                                        }}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        placeholder={staticText.searchText}
                                                                        value={values.keyword}
                                                                    />
                                                                </td>
                                                                <td
                                                                    className="btnContiner"
                                                                    style={{ width: "30%", paddingTop: "3px" }}
                                                                >
                                                                    <button
                                                                        type="submit"
                                                                        className="btnSearch"
                                                                        style={{ height: "100%" }}
                                                                    >
                                                                        <SearchIcon style={{ marginTop: "5px" }} />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </FormControl>
                                            </form>
                                        )}
                                    </Formik>
                                    <Box m={2} textAlign="center">
                                        <span>ارسال رایگان برای ساکنین مشهد مقدس</span>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12}></Grid>
                        </Grid>
                        <Grid
                            container
                            className={`${base} nuts-area`}
                            style={{
                                marginTop: "6px",
                                backgroundImage: "url(/images/home-page-header/mask.png)",
                                position: "relative",
                                bottom: "-1px",
                                right: "-15px",
                            }}
                        >
                            <Grid item xs={8}>
                                <Box evelation={0}>
                                    <img
                                        alt=""
                                        src="/images/home-page-header/nuts.png"
                                        style={{ width: "100%", position: "relative", top: "50px" }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box
                                    evelation={0}
                                    textAlign="left"
                                    ml={-5}
                                    mt={-1}
                                    mr={0}
                                    pr={0}
                                    mb={0}
                                    pb={0}
                                >
                                    <img
                                        alt=""
                                        src="/images/home-page-header/leaves.png"
                                        id="bargHeaderGoshi"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Drawer
                        {...{
                            anchor: "right",
                            open: drawerOpen,
                            onClose: handleDrawerClose,
                            classes: { paper: drawerPaper },
                        }}
                    >
                        <div className={drawerContainer + " mobileMenu"}>
                            <div
                                className="menu-top-box"
                                style={{
                                    backgroundImage: `url('/images/home-page-header/menu-top.png')`,
                                }}
                            >
                                <img
                                    src="/images/home-page-header/logo.png"
                                    className="menu-img"
                                />
                                <h3 className="menu-h3">{staticText.mainTitle}</h3>
                            </div>
                            <p>&nbsp;</p>
                            {getDrawerChoices()}
                            <p className="menuLang">
                                <GTranslateIcon /> <span>{staticText.lang}</span>
                            </p>
                            <RadioGroup
                                row
                                aria-label="position"
                                name="position"
                                defaultValue={lang}
                                style={{ marginRight: "40px" }}>
                                <FormControlLabel
                                    value="fa"
                                    color="#ffffff"
                                    control={<Radio color="success" />}
                                    label="فارسی"
                                />
                                <FormControlLabel
                                    value="ar"
                                    color="#ffffff"
                                    control={<Radio color="success" />}
                                    label="عربی"
                                />
                            </RadioGroup>
                        </div>
                    </Drawer>
                </Toolbar>
            </AppBar>
        );
    };

    const getDrawerChoices = () => {
        return headersData.map(({ label, href, icon }) => {
            return (
                <>
                    <Link
                        {...{
                            component: RouterLink,
                            to: href,
                            color: "inherit",
                            style: { textDecoration: "none" },
                            key: label,
                            className: "menuLink",
                        }}
                    >
                        <MenuItem className="menuItem">
                            {icon === "home" ? (
                                <HomeIcon />
                            ) : icon === "products" ? (
                                <ListAltIcon />
                            ) : icon === "articels" ? (
                                <MenuBookIcon />
                            ) : icon === "about" ? (
                                <InfoIcon />
                            ) : (
                                <PhoneIcon />
                            )}
                            {label}
                        </MenuItem>
                    </Link>
                </>
            );
        });
    };

    const getMenuButtons = () => {
        return headersData.map(({ label, href }) => {
            return (
                <Button
                    {...{
                        key: label,
                        color: "inherit",
                        to: href,
                        component: RouterLink,
                        className: menuButton,
                    }}
                >
                    {label}
                </Button>
            );
        });
    };

    return (
        <>
            {tabletView
                ? displayTablet()
                : mobileView
                    ? displayMobile()
                    : displayDesktop()}
            <LoginModal open={isModalOpen} onClose={onClose} redirect={true} />
        </>
    );
};

Header.propTypes = {
    lang: PropTypes.string,
};

export default Header;
